import {isFinanceSelfEmploymentFlow} from './statusConnectionFlow';
import {RegistrationWorkStatus} from './types';

export const MY_TAX_LOAD_ERROR_TITLE = 'Ошибка при загрузке';

export const MY_TAX_LOAD_ERROR_DESCRIPTION =
	'Не удалось получить данные. Проверьте подключение к интернету и попробуйте снова';

export const MY_TAX_LOAD_ERROR_RETRY_LABEL = 'Обновить';

export const getMyTaxLoadErrorTitle = (workStatus?: RegistrationWorkStatus | null): string => {
	return isFinanceSelfEmploymentFlow(workStatus ?? null) ? 'Что-то не так' : MY_TAX_LOAD_ERROR_TITLE;
};

export const getMyTaxLoadErrorDescription = (workStatus?: RegistrationWorkStatus | null): string => {
	return isFinanceSelfEmploymentFlow(workStatus ?? null)
		? 'Ошибка запроса, попробуйте еще раз'
		: MY_TAX_LOAD_ERROR_DESCRIPTION;
};

export const getMyTaxLoadErrorRetryLabel = (workStatus?: RegistrationWorkStatus | null): string => {
	return isFinanceSelfEmploymentFlow(workStatus ?? null) ? 'Попробовать заново' : MY_TAX_LOAD_ERROR_RETRY_LABEL;
};
